exports.ById = {
  1: {
    Id: 1,
    RegionId: 1,
    Name: 'ASEAN Region',
    Localization: 'region.asean_region'
  },
  2: {
    Id: 2,
    RegionId: 2,
    Name: 'Asia Pacific',
    Localization: 'region.asia_pacific'
  },
  3: {
    Id: 3,
    RegionId: 3,
    Name: 'Central America',
    Localization: 'region.central_america'
  },
  4: {
    Id: 4,
    RegionId: 4,
    Name: 'Central Europe',
    Localization: 'region.central_europe'
  },
  5: {
    Id: 5,
    RegionId: 5,
    Name: 'Eastern Europe',
    Localization: 'region.eastern_europe'
  },
  6: {
    Id: 6,
    RegionId: 6,
    Name: 'EMEA',
    Localization: 'region.emea'
  },
  7: {
    Id: 7,
    RegionId: 7,
    Name: 'Emerging Markets',
    Localization: 'region.emerging_markets'
  },
  8: {
    Id: 8,
    RegionId: 8,
    Name: 'European Union',
    Localization: 'region.european_union'
  },
  9: {
    Id: 9,
    RegionId: 9,
    Name: 'Greater China',
    Localization: 'region.greater_china'
  },
  10: {
    Id: 10,
    RegionId: 10,
    Name: 'Latin America',
    Localization: 'region.latin_america'
  },
  11: {
    Id: 11,
    RegionId: 11,
    Name: 'Middle East',
    Localization: 'region.middle_east'
  },
  12: {
    Id: 12,
    RegionId: 12,
    Name: 'Middle East And Africa',
    Localization: 'region.middle_east_and_africa'
  },
  13: {
    Id: 13,
    RegionId: 13,
    Name: 'Middle East And North Africa',
    Localization: 'region.middle_east_and_north_africa'
  },
  14: {
    Id: 14,
    RegionId: 14,
    Name: 'Nordic Countries',
    Localization: 'region.nordic_countries'
  },
  15: {
    Id: 15,
    RegionId: 15,
    Name: 'North America',
    Localization: 'region.north_america'
  },
  16: {
    Id: 16,
    RegionId: 16,
    Name: 'OECD',
    Localization: 'region.oecd'
  },
  17: {
    Id: 17,
    RegionId: 17,
    Name: 'Pan Asian',
    Localization: 'region.pan_asian'
  },
  18: {
    Id: 18,
    RegionId: 18,
    Name: 'Pan European',
    Localization: 'region.pan_european'
  },
  19: {
    Id: 19,
    RegionId: 19,
    Name: 'South America',
    Localization: 'region.south_america'
  },
  20: {
    Id: 20,
    RegionId: 20,
    Name: 'Western Asia',
    Localization: 'region.western_asia'
  },
  21: {
    Id: 21,
    RegionId: 21,
    Name: 'Western Europe',
    Localization: 'region.western_europe'
  },
  22: {
    Id: 22,
    RegionId: 22,
    Name: 'Australia Oceania',
    Localization: 'region.australia_oceania'
  },
  23: {
    Id: 23,
    RegionId: 23,
    Name: 'Americas',
    Localization: 'region.americas'
  },
  24: {
    Id: 24,
    RegionId: 24,
    Name: 'Australia Developed Countries Expansion',
    Localization: 'region.australia_developed_countries_expansion'
  },
  25: {
    Id: 25,
    RegionId: 25,
    Name: 'Australia - New Zealand - UK - USA',
    Localization: 'region.australia_new_zealand_uk_usa'
  },
  26: {
    Id: 26,
    RegionId: 26,
    Name: 'EAEU',
    Localization: 'region.eaeu'
  },
  27: {
    Id: 27,
    RegionId: 27,
    Name: 'European Union Plus',
    Localization: 'region.european_union_plus'
  }
};
